// Corrections review and the chat's Report Issue button are hidden for now; set to true to show both again.
export const AI_CORRECTIONS_ENABLED = false;
